import { Component, OnInit } from '@angular/core';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { Chart } from 'chart.js';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { concat } from 'rxjs';
import { browserRefresh } from 'src/app/app.component';
import { Subject } from 'rxjs';
import { User} from 'src/app/Model/User/user.model';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserRole } from 'src/app/Model/Role/user-role.model';

@Component({
  selector: 'app-branch-report',
  templateUrl: './branch-report.component.html',
  styleUrls: ['./branch-report.component.css']
})
export class BranchReportComponent implements OnInit {

  selectedview='branchreport';
  halfdonutForm:FormGroup;
  datasetforallappointmentfromallbranch;
  chart:any=[];
  monthValue=[];
  months=[];
  apt;
  allsalesrepapt;
  lookingforapt;
  describesyouapt;
  requesttypeapt;
key;
value;
totalApt;
error;


newData;


requesttypeforbranchsquare;
vegarequesttypeforbranchsquare;
lawrencerequesttypeforbranchsquare;
janerequesttypeforbranchsquare;
stlaurentrequesttypeforbranchsquare;

totalsalesrepsquare;
totalappointmentsquare;
totallookingForsquare;
totaldescribesYousquare;
totalrequestTypesquare;

populardescribesyousquarekey;
populardescribesyousquarevalue;
popularlookingforsquarekey;
popularlookingforsquarevalue;

allBranchlookingFortable;
allBranchlookingfortablekey;
allBranchlookingfortablevalue;
tablelookingforarray=[];

allBranchdescribesYoutable;
allBranchdescribesYoutablekey;
allBranchdescribesYoutablevalue;
tabledescribesYouarray=[];

allBranchrequestTypetable;
allBranchrequestTypetablekey;
allBranchrequestTypetablevalue;
tablerequestTypearray=[];

tablelookingforkey;
tablelookingforvalue;

allBranchTotalApt;
allBranchTotalAptLocation;
allBranchTotalAptMonthvalue;
dataStackedBarChart;


allBranchTotalRequestTypeLocation;
allBranchTotalRequestTypeMonthvalue;
requestTypebarChart;
requestTypemonthsdata;
requestTypemonthdatavalue;

allBranchTotalRequestType;
allBranchTotalRequestTypekey;
allBranchTotalRequestTypevalue;


halfdonutlookingforapt
halfdonutlookingforkey;
halfdonutlookingforvalue;
halfdonutlookingforid

halfdonutdescribesyouapt
halfdonutdescribesyoukey;
halfdonutdescribesyouvalue;

halfdonutrequesttypeapt
halfdonutrequesttypekey;
halfdonutrequesttypevalue;

randomcolorarray=['#003366','green','#e65c00','#0099ff,#666633','#800000']


currentUser:User;
username;
branch;
role;
loggedInUsername
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;

reportyear;

refresh: Subject<any> = new Subject();

  constructor(private _appointment: AppointmentService,
    private actroute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private fb: FormBuilder) { 


      
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.role=this.currentUser.role;


        this.loggedInUsername=this.currentUser.userName;
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
    }

  ngOnInit(): void {
   
    this.actroute.paramMap.subscribe(params => {
      // This is never executed, for route is not recognized
      // let myArray=params.getAll('extra');
      this.reportyear = params.get('extra');
      //console.log(this.reportyear);

    this.gettotalappointmentsquare();
this.gettotallookdescreqsquare();
this.gettotalsalesrepsquare();
this.getpopulardescribesYousquare();
this.getpopularlookingForsquare();
this.getallappointmentrequesttypeforbranchsquare();

  
this.refresh.next();
        // register plugin
Chart.plugins.register({
  beforeDraw: function(chart) {
    //.log(chart.canvas.id);
    if(chart.canvas.id=="trainingcompletioncanvas" || chart.canvas.id=="sessioncompletioncanvas" || chart.canvas.id=="depletingconsumablecanvas" ){
    //if(chart.canvas.tagName
  
      var data = chart.data.datasets[0].data;
    //if(+data[0]==null && +data[1]==null ){
      //+data[0]==0;
      //+data[1]==0;
   // }
      var percentvalue=Math.round((+data[0]/+data[1])*100)
        //console.log(percentvalue);
      
     





      var width = chart.canvas.width,
          height =chart.canvas.height,
          
          ctx = chart.canvas.getContext('2d');
      
      ctx.restore();
      var fontSize = (height / 8).toFixed(2);
      ctx.font = fontSize + "px Arial";
      ctx.textBaseline = "middle";
      ctx.textAlign = 'center';
      var text =percentvalue.toString()+"%",
        //  textX = Math.round((width - ctx.measureText(text).width) / 4.2),
        //  textY = height / 3;
        textX=((chart.chartArea.left + chart.chartArea.right) / 2),
      textY=(((chart.chartArea.top + chart.chartArea.bottom) /2));
      ctx.fillText(text, textX, textY +30);
      ctx.save();
  }},

  beforeRender: function (chart) {
    if (chart.config.options.showAllTooltips) {
        // create an array of tooltips
        // we can't use the chart tooltip because there is only one tooltip per chart
        chart.pluginTooltips = [];
        chart.config.data.datasets.forEach(function (dataset, i) {
            chart.getDatasetMeta(i).data.forEach(function (sector, j) {
                chart.pluginTooltips.push(new Chart.Tooltip({
                    _chart: chart.chart,
                    _chartInstance: chart,
                    _data: chart.data,
                    _options: chart.options,
                    _active: [sector]
                }, chart));
            });
        });

        // turn off normal tooltips
        chart.options.tooltips.enabled = false;
    }
}
});


this.halfdonutForm = this.fb.group({
  halfdonutlookingFor: new FormControl(''),
  halfdonutdescribesYou: new FormControl(''),
  halfdonutrequestType: new FormControl(''),
    
 });

var  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var d = new Date();
var monthName=months[d.getMonth()];
this.switchhalfdonutlookingFormonth(monthName);
this.switchhalfdonutdescribesYoumonth(monthName);
this.switchhalfdonutrequestTypemonth(monthName);

this.halfdonutForm.patchValue({
   halfdonutdescribesYou: monthName,
   halfdonutlookingFor: monthName,
   halfdonutrequestType: monthName,
})



/************************************************************************************************************************************ */
/**
 * BAR CHART - APPOINTMENT PER MONTH FROM ALL BRANCH
 *************************************************************************************************************************************/

this._appointment.getAllAppointmentFromAllBranchsPerMonth(this.reportyear).subscribe(
  (res) => {
    console.log(res);
/**
 * 1020 Lawrence: {November: "53", December: "207"}
3050 Vega: {November: "4", December: "50"}
8899 Jane St: {November: "454", December: "297"}
 */
    this.allBranchTotalApt = res[0];
    console.log(this.allBranchTotalApt);
      this.allBranchTotalAptLocation=Object.keys(this.allBranchTotalApt);
      this.allBranchTotalAptMonthvalue=Object.values(this.allBranchTotalApt);
    
//console.log(  this.allBranchTotalApt[this.allBranchTotalAptLocation[0]]);
//console.log(this.allBranchTotalAptMonthvalue);

    

      var barChartData = {
        labels:[],
        
       
        datasets: [ ]
      };
      var chartOptions = {
        responsive: true,
        bezierCurve:true,
        title: {
          display: true,
          text: "Total Appointments"
        },
        
        scales: {
          yAxes: [{
            ticks: {
              //stepSize: 100,           
              beginAtZero: true,
              autoSkip: false
            }
          }  ]
          
        } 
        
      }




//console.log(this.allBranchTotalAptLocation);
var coloor=["#003b76",'#890000',"#004e27","#f5a442"];
  for(var j=0; j< this.allBranchTotalAptLocation.length; j++){

    this.months=this.allBranchTotalApt[this.allBranchTotalAptLocation[j]];
    //console.log(this.months);
 
  // console.log(Object.keys(this.months));

    barChartData.labels= Object.keys(this.months); //Jan,Feb,Mar
  barChartData.datasets.push({
  
    label:this.allBranchTotalAptLocation[j],//lawrence, Jane, Mississuaga
  borderColor:coloor[j],
    backgroundColor: 'transparent',//this.randomcolorarray[j],
    borderWidth: 3,
    //stepSize: 100,
    data:Object.values(this.months),//0,0,1,0,2,455
    //lineTension: 0.5,         
    
  })

//}
  }

 //this.monthValue.push(Object.values(item));
//});
//console.log(this.monthValue);
//console.log(month);

      var ctx = document.getElementById('myCharta');
      var myChart = new Chart(ctx, {
        type: "line",
        // /label: this.months,
    data: barChartData,
    options: chartOptions,
    bezierCurve:true,
      });
      
      



  });









    /************************************************************** */
 //BAR CHART - FOR BRANCH APPOINTMEN PER MONTH
 /************************************************************** */
 
 this._appointment.getAllAppointmentForBranchPerMonth(this.branch,this.reportyear).subscribe(
  (res) => {
    console.log(res);

    this.apt = res[0];
   // console.log(this.apt);
      this.key=Object.keys(this.apt);
      this.value=Object.values(this.apt);
      
   //   console.log(this.value);
 /*for(let val of this.value){
   
   this.totalApt+=val;
   console.log(this.totalApt);
}*/
 //console.log(this.totalApt);
 const colors=[];
 for(var j=0; j< this.key.length; j++){
 var fillColor = 'rgba(' + Math.floor(Math.random() * 150) + ',' + Math.floor(Math.random() * 200) + ',' + Math.floor(Math.random() * 200) + ', 0.7)';
 colors.push(fillColor);
}
 var ctx = document.getElementById('BranchChart');
var myJanehart = new Chart(ctx, {
    type: 'bar',
    data: {
        labels: this.key,
        datasets: [{
            labels: '# of Appointments',
            data: this.value,
            backgroundColor: colors,
            //],
          
            borderWidth: 1
        }]
    },
    options: {
      responsive: true,
      
      title: {
          display: true,
          position: "top",
          text: "",
         
          fontColor: "#111"
      },
        scales: {

          
            yAxes: [{
                ticks: {
                  min:0,
                    beginAtZero: true
                }
            }]
        },
        legend: {
          display: false,
          position: "left",
          labels: {
              fontColor: "#333",
              fontSize: 12
          }
        }
        
    }
});





 },
  (err) => {
    this.error = err;
  }
); 




   /************************************************************** */
 //PIE CHART -  all completed appointments for all salesrep in all branch
 /************************************************************** */

this._appointment.getAllSalesRepCompletedAppointmentForBranch(this.branch,this.reportyear).subscribe(
  (res) => {
 //   console.log(res);

    this.allsalesrepapt = res[0];
    console.log(this.allsalesrepapt);
      this.key=Object.keys(this.allsalesrepapt);
      this.value=Object.values(this.allsalesrepapt);
      
     // console.log(this.value);
var canvas=document.getElementById("canvas");
    this.chart = new Chart('canvas', {
      type: 'doughnut',
      data: {
        labels:this.key,// this.key,
        datasets: [
          {
            data:this.value,//this.value,
            backgroundColor: ["#00CC66","#003366","#3e95cd","#8e5ea2","#3cba9f","#e8c3b9","#c45850","#ff6666","#3399FF","#FFFF66","#005ce6","#9999FF","#FF6666","#FFCCFF","#E0E0E0","#FFB266","#00FF80","#00FFFF","#0066CC","#9933FF","#FFFF00","#00CC66","#CC0066","#4286f4","#JEDD33",'#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
            fill: false,
       //     borderColor: this.getRandomColor(),
            borderWidth: [1, 1, 1, 1, 1]
          }
        ]
      },
      //options
       options : {
        responsive: true,
        title: {
            display: true,
            position: "top",
            text: "Total Appointment By Sales Rep",
           
            fontColor: "#111"
        },
        cutoutPercentage: 60,
        maintainAspectRatio: true,
       
        
        legend: {
            display: false,
            position: "left",
            labels: {
             
                fontColor: "#333",
                fontSize: 12
            }
        }
    }
 
        
      
     });
 },
  (err) => {
    this.error = err;
  }
); 








/************************************************************************************************************************ 
 * PIE CHART -  LookingFor field from all appointments from  branch
 * ******************************************************************************************************************/


this._appointment.getAllAppointmentLookingForForBranch(this.branch,this.reportyear).subscribe(
  (res) => {
  //  console.log(res);

    this.lookingforapt = res[0];
  //  console.log(this.lookingforapt);
      this.tablelookingforkey=Object.keys(this.lookingforapt);
      this.tablelookingforvalue=Object.values(this.lookingforapt);
      
    //  console.log(this.tablelookingforvalue);

var canvas=document.getElementById("lookingForcanvas");
    this.chart = new Chart('lookingForcanvas', {
      type: 'doughnut',
      data: {
        labels:this.tablelookingforkey,// this.key,
        datasets: [
          {
            data:this.tablelookingforvalue,//this.value,
            backgroundColor: [
              "#009d00", "#008900", "#007600","#006200", "#004e00", "#003b00","#002700","#001400", '#CC80CC', 
              '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
              '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', "#00CC66","#ff6666","#3399FF","#FFFF66","#005ce6","#9999FF","#FF6666","#FFCCFF","#E0E0E0","#FFB266","#00FF80","#00FFFF","#0066CC","#9933FF","#FFFF00","#00CC66","#CC0066","#4286f4","#JEDD33",'#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
            fill: false,
       //     borderColor: this.getRandomColor(),
            borderWidth: [1, 1, 1, 1, 1]
          }
        ]
      },
      //options
       options : {
        responsive: true,
        title: {
            display: true,
            position: "top",
            text: "Clients Interest",
           
            fontColor: "#111"
        },
        cutoutPercentage: 60,
        maintainAspectRatio: true,
       
        
        legend: {
            display: true,
            position: "left",
            labels: {
                fontColor: "#333",
                fontSize: 12
            }
        }
    }
 
        
      
     });
 },
  (err) => {
    this.error = err;
  }
); 

/************************************************************************************************************************ 
 * PIE CHART -  describesYou field from all appointments from  branch
 * ******************************************************************************************************************/


this._appointment.getAllAppointmentDescribesYouForBranch(this.branch,this.reportyear).subscribe(
  (res) => {
   // console.log(res);

    this.describesyouapt = res[0];
    //console.log(this.describesyouapt);
      this.key=Object.keys(this.describesyouapt);
      this.value=Object.values(this.describesyouapt);
      
     // console.log(this.value);
var canvas=document.getElementById("describesYoucanvas");
    this.chart = new Chart('describesYoucanvas', {
      type: 'doughnut',
      data: {
        labels:this.key,// this.key,
        datasets: [
          {
            data:this.value,//this.value,
            backgroundColor: [
              "#4da6ff","#1a8dff","#0073e6","#005ab3", "#0000d8","#0000c4","#00009d","#000076","#00003b","#3e95cd","#8e5ea2","#3cba9f", '#CC80CC', 
              '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
              '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', "#00CC66","#ff6666","#3399FF","#FFFF66","#005ce6","#9999FF","#FF6666","#FFCCFF","#E0E0E0","#FFB266","#00FF80","#00FFFF","#0066CC","#9933FF","#FFFF00","#00CC66","#CC0066","#4286f4","#JEDD33",'#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
            fill: false,
       //     borderColor: this.getRandomColor(),
            borderWidth: [1, 1, 1, 1, 1]
          }
        ]
      },
      //options
       options : {
        responsive: true,
        title: {
            display: true,
            position: "top",
            text: "Clients Type",
           
            fontColor: "#111"
        },
        cutoutPercentage: 60,
        maintainAspectRatio: true,
       
        
        legend: {
            display: true,
            position: "left",
            labels: {
                fontColor: "#333",
                fontSize: 12
            }
        }
    }
 
        
      
     });
 },
  (err) => {
    this.error = err;
  }
);




/************************************************************************************************************************ 
 * PIE CHART -  requestType field from all appointments from branch
 * ******************************************************************************************************************/


this._appointment.getAllAppointmentRequestTypeForBranch(this.branch,this.reportyear).subscribe(
  (res) => {
  //  console.log(res);

    this.requesttypeapt = res[0];
   // console.log(this.requesttypeapt);
      this.key=Object.keys(this.requesttypeapt);
      this.value=Object.values(this.requesttypeapt);
      
   //   console.log(this.value);
var canvas=document.getElementById("requestTypecanvas");
    this.chart = new Chart('requestTypecanvas', {
      type: 'doughnut',
      data: {
        labels:this.key,// this.key,
        datasets: [
          {
            data:this.value,//this.value,
            backgroundColor: [ 
              "#eb0000","#d80000","#b10000","#890000","#620000","#3b0000","#140000","#3cba9f","#e8c3b9",
              '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
              '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', "#00CC66","#ff6666","#3399FF","#FFFF66","#005ce6","#9999FF","#FF6666","#FFCCFF","#E0E0E0","#FFB266","#00FF80","#00FFFF","#0066CC","#9933FF","#FFFF00","#00CC66","#CC0066","#4286f4","#JEDD33",'#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',],
            fill: false,
       //     borderColor: this.getRandomColor(),
            borderWidth: [1, 1, 1, 1, 1]
          }
        ]
      },
      //options
       options : {
        responsive: true,
        title: {
            display: true,
            position: "top",
            text: "Request Type",
           
            fontColor: "#111"
        },
        cutoutPercentage: 60,
        maintainAspectRatio: true,
       
        
        legend: {
            display: true,
            position: "left",
            labels: {
                fontColor: "#333",
                fontSize: 12
            }
        }
    }
 
        
      
     });
 },
  (err) => {
    this.error = err;
  }
); 


























/*********************************************************************************************************************************************************************
 * BAR CHART for requestType for all locatiom
 *********************************************************************************************************************************************************/


this._appointment.getAllRequestTypeAllBranchPerMonth(this.reportyear).subscribe(
  (res) => {
    console.log(res);

    this.allBranchTotalRequestType= res[0];
    //console.log(this.allBranchTotalRequestType);
      this.allBranchTotalRequestTypeLocation=Object.keys(this.allBranchTotalRequestType);
      this.allBranchTotalRequestTypeMonthvalue=Object.values(this.allBranchTotalRequestType);
     // console.log(this.allBranchTotalRequestTypeLocation);



      
      var requestTypebarChartData= {
        labels:[],
        
       
        datasets: [ ]
      };
      var requestTypechartOptions = {
        responsive: true,
        bezierCurve:true,
        title: {
          display: true,
          text: "Total Request Type"
        },
        
        scales: {
          yAxes: [{
            ticks: {
            //  stepSize: 10,           
              beginAtZero: true,
              autoSkip: false
            }
          }  ]
          
        } 
        
      }

    //  console.log(this.allBranchTotalRequestTypeLocation);//Lawrence,Mississuaga,Jane
      for(var j=0; j< this.allBranchTotalRequestTypeLocation.length; j++){
    

        this.requestTypemonthsdata=this.allBranchTotalRequestType[this.allBranchTotalRequestTypeLocation[j]];
        //console.log(this.requestTypemonthsdata);
        /**December: {Email: "13", Browsing: "109", "Walk-in ": "27", "": "67", Day Off: "15", …}
        November: {"": "181", Browsing: "104", Phone: "3", Appointment: "224", "Walk-in ": "147", …}
        October: {"": "1"}
        */
     
       //console.log(Object.keys(this.requestTypemonthsdata));//December,November,October
       //console.log(Object.values(this.requestTypemonthsdata));
       var monthsactualdetails=Object.values(this.requestTypemonthsdata);
       /*0: {Appointment: "2", "": "2"}
       1: {Day Off: "4", Appointment: "45", "Walk-in ": "1 */

       for(var k=0; k< monthsactualdetails.length; k++){
       //console.log(Object.values(monthsactualdetails));
       this.requestTypemonthdatavalue=Object.values(this.requestTypemonthsdata);
       //console.log( this.requestTypemonthdatavalue);

     // console.log(Object.keys(monthsactualdetails[k]));
      //console.log(Object.values(monthsactualdetails[k]));
      var ok=Object.keys(monthsactualdetails[k]);
        requestTypebarChartData.labels= Object.keys(this.requestTypemonthsdata); //Jan,Feb,Mar
        requestTypebarChartData.datasets.push({
    
        label:ok[k],//lawrence, Jane, Mississuaga
     // borderColor:this.randomcolorarray[k],
        backgroundColor: ['#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF',
        '#66994D', '#003366',"#FF4D4D","#3e95cd","#8e5ea2","#3cba9f","#e8c3b9","#c45850", '#4D8000', '#B33300', '#CC80CC', 
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399'],//this.randomcolorarray[k],
        borderWidth: 3,
        stepSize: 100,
        data:Object.values( monthsactualdetails[k]),//0,0,1,0,2,455
        //lineTension: 0.5,         
        
      });
    
    }
  }


    var ctx = document.getElementById('requestTypeGraph');
    var myChart = new Chart(ctx, {
      type: "bar",
      // /label: this.months,
  data: requestTypebarChartData,
  options: requestTypechartOptions,
  bezierCurve:true,
    });
    
      });
    
    
      




/*********************************************************************************************************************************************************************
 * TABLE for lookingFor for all locatiom
 *********************************************************************************************************************************************************/


this._appointment.getAlllookingForAllBranch(this.reportyear).subscribe(
  (res) => {
    console.log(res);

    this.allBranchlookingFortable= res[0];

    this.tablelookingforarray=Object.entries(this.allBranchlookingFortable).map(([key,value])=>{
      const y={['  ']:key}
      return Object.assign({},y,value)
    })
    
    const headers=Object.keys(this.tablelookingforarray[0])
    console.log(headers)
    var stringversion=JSON.stringify(this.tablelookingforarray,null,4);
   // console.log(this.newData)

 /**   console.log(this.allBranchlookingFortable);
      this.allBranchlookingfortablekey=Object.keys(this.allBranchlookingFortable);
      this.allBranchlookingfortablevalue=Object.values(this.allBranchlookingFortable);
      console.log(this.allBranchlookingfortablekey);
      //var jjj=Object.values(this.allBranchlookingfortablevalue);
     for(var j=0; j< this.allBranchlookingfortablevalue.length; j++){
      this.tablelookingforarray=[];

this.tablelookingforarray.push(this.allBranchlookingfortablekey[j]);
console.log(this.tablelookingforarray);
this.tablelookingforarray.push.apply(this.tablelookingforarray,Object.values(this.allBranchlookingfortablevalue[j]));

//this.allBranchlookingfortablekey[j].push.apply(this.allBranchlookingfortablekey[j],Object.values(this.allBranchlookingfortablevalue[j]));
this.newarray.push(this.tablelookingforarray);

//console.log(Object.values(this.allBranchlookingfortablevalue[j]));

      } **/

  },
   (err) => {
     this.error = err;
   }
 ); 



 /*********************************************************************************************************************************************************************
 * TABLE for describesYou for all locatiom
 *********************************************************************************************************************************************************/


this._appointment.getAlldescribesYouAllBranch(this.reportyear).subscribe(
  (res) => {
    console.log(res);

    this.allBranchdescribesYoutable= res[0];
console.log(this.allBranchdescribesYoutable);
    this.tabledescribesYouarray=Object.entries(this.allBranchdescribesYoutable).map(([key,value])=>{
      const y={['  ']:key}
      return Object.assign({},y,value)
    })
    
    const headers=Object.keys(this.tabledescribesYouarray[0])
    console.log(headers)
    var stringversion=JSON.stringify(this.tabledescribesYouarray,null,4);


  },
   (err) => {
     this.error = err;
   }
 ); 




 
 /*********************************************************************************************************************************************************************
 * TABLE for requestType for all locatiom
 *********************************************************************************************************************************************************/


this._appointment.getAllrequestTypeAllBranch(this.reportyear).subscribe(
  (res) => {
    console.log(res);

    this.allBranchrequestTypetable= res[0];

    this.tablerequestTypearray=Object.entries(this.allBranchrequestTypetable).map(([key,value])=>{
      const y={['  ']:key}
      return Object.assign({},y,value)
    })

    const headers=Object.keys(this.tablerequestTypearray[0])
    console.log(headers)
    var stringversion=JSON.stringify(this.tablerequestTypearray,null,4);


  },
   (err) => {
     this.error = err;
   }
 ); 





  });


      
  }



/****************************************************************************************
 *    half Doughnut
 * 
 ****************************************************************/

switchhalfdonutlookingFormonth(month){

  this._appointment.getAllAppointmentLookingForEachMonthForBranch(month,this.branch,this.reportyear).subscribe(
    (res) => {
      console.log(res);
  
      this.halfdonutlookingforapt = res[0];
     // console.log(this.halfdonutlookingforapt);
        this.halfdonutlookingforkey=Object.keys(this.halfdonutlookingforapt);
        this.halfdonutlookingforvalue=Object.values(this.halfdonutlookingforapt);
  //console.log(this.halfdonutlookingforkey);
  //console.log(this.halfdonutlookingforvalue);
  const productinquiryhalfdonut=document.getElementById("productinquiryhalfdonut");
  
  //var text=(Math.round(+this.depletingconsumablepercentage[0]/+this.depletingconsumablepercentage[1])*100).toString()+"% <br>"+"Depleting Consumables";
  
  this.chart = new Chart('productinquiryhalfdonut', {
    
    type: 'doughnut',
    data: {
      labels:this.halfdonutlookingforkey,
      
      datasets: [
        {
          data:this.halfdonutlookingforvalue,
          backgroundColor: ["#009d00", "#008900", "#007600","#006200", "#004e00", "#003b00","#002700","#001400", "#E5FFF5","#97FFD7","#49FFB9","#5ACA4A","#1B5208","#3e95cd","#8e5ea2","#3cba9f","#e8c3b9","#c45850","#ff6666","#3399FF","#FFFF66","#005ce6","#9999FF","#FF6666","#FFCCFF","#E0E0E0","#FFB266","#00FF80","#00FFFF","#0066CC","#9933FF","#FFFF00","#00CC66","#CC0066","#4286f4"],
          fill: false,
        //  borderColor: ["#00CC66","#003366"],
          borderWidth: [1, 1, 1, 1, 1]
        }
      ]
    },
    //options
     options : {
      tooltips: {
        enabled: true,
        callbacks: {
          label: (tooltipItem, data) => {
            const dataset = data.datasets[tooltipItem.datasetIndex];
            const total = dataset.data.reduce((previousValue, currentValue) => previousValue + currentValue);
            const currentValue = dataset.data[tooltipItem.index];
            const percentage = Math.floor(((currentValue / total) * 100) + 0.5);
            return `${data.labels[tooltipItem.index]}: ${percentage}%`;
          }
        }
      },
      responsive: true,
      title: {
          display: true,
          position: "bottom",
          text: "Product",
         
          fontColor: "#111"
      },
      cutoutPercentage: 70,
      maintainAspectRatio: false,
      rotation: 1 * Math.PI,
      circumference: 1 * Math.PI,
      
      legend: {
          display: true,
          position: "top",
          labels: {
              fontColor: "#333",
              fontSize: 10,
          }
      }
  }
  
      
    
      });
   },
    (err) => {
      this.error = err;
    }
  ); 
  
  
  
   }
  


   

/****************************************************************************************
 *    half Doughnut
 * 
 ****************************************************************/

switchhalfdonutdescribesYoumonth(month){

  this._appointment.getAllAppointmentdescribesYouEachMonthForBranch(month,this.branch,this.reportyear).subscribe(
    (res) => {
      console.log(res[0]);
  
      this.halfdonutdescribesyouapt = res[0];
     // console.log(this.halfdonutlookingforapt);
        this.halfdonutdescribesyoukey=Object.keys(this.halfdonutdescribesyouapt);
        this.halfdonutdescribesyouvalue=Object.values(this.halfdonutdescribesyouapt);
  //console.log(this.halfdonutdescribesyoukey);
  //console.log(this.halfdonutdescribesyouvalue);
  const productinquiryhalfdonut=document.getElementById("describesyouhalfdonut");
  
  //var text=(Math.round(+this.depletingconsumablepercentage[0]/+this.depletingconsumablepercentage[1])*100).toString()+"% <br>"+"Depleting Consumables";
  
  this.chart = new Chart('describesyouhalfdonut', {
    
    type: 'doughnut',
    data: {
      labels:this.halfdonutdescribesyoukey,
      
      datasets: [
        {labels:this.halfdonutdescribesyouvalue,
          data:this.halfdonutdescribesyouvalue,
          backgroundColor: ["#4da6ff","#1a8dff","#0073e6","#005ab3","#00003b","#3e95cd","#8e5ea2","#3cba9f","#e8c3b9","#c45850","#ff6666","#3399FF","#FFFF66","#005ce6","#9999FF","#FF6666","#FFCCFF","#E0E0E0","#FFB266","#00FF80","#00FFFF","#0066CC","#9933FF","#FFFF00","#00CC66","#CC0066","#4286f4"],
          fill: false,
        //  borderColor: ["#00CC66","#003366"],
          borderWidth: [1, 1, 1, 1, 1]
        }
      ]
    },
    //options
     options : {
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function(tooltipItems, data) {
            return data.labels[tooltipItems.index] + ': ' + data.datasets[0].data[tooltipItems.index] + '%';
          }
        }
      },
      responsive: true,
      title: {
          display: true,
          position: "bottom",
          text: "Clients",
         
          fontColor: "#111"
      },
      cutoutPercentage: 70,
      maintainAspectRatio: false,
      rotation: 1 * Math.PI,
      circumference: 1 * Math.PI,
      
      legend: {
          display: true,
          position: "top",
          labels: {
              fontColor: "#333",
              fontSize: 10,
          }
      },
    
       
      
      
      
      
  }
  
      
    
      });
   },
    (err) => {
      this.error = err;
    }
  ); 
  }



  
/****************************************************************************************
 *    half Doughnut
 * 
 ****************************************************************/

switchhalfdonutrequestTypemonth(month){

  this._appointment.getAllAppointmentrequestTypeEachMonthForBranch(month,this.branch, this.reportyear).subscribe(
    (res) => {
      console.log(res);
  
      this.halfdonutrequesttypeapt = res[0];
     // console.log(this.halfdonutlookingforapt);
        this.halfdonutrequesttypekey=Object.keys(this.halfdonutrequesttypeapt);
        this.halfdonutrequesttypevalue=Object.values(this.halfdonutrequesttypeapt);
  //console.log(this.halfdonutrequesttypekey);
  //console.log(this.halfdonutrequesttypevalue);
  const productinquiryhalfdonut=document.getElementById("requesttypehalfdonut");
  
  //var text=(Math.round(+this.depletingconsumablepercentage[0]/+this.depletingconsumablepercentage[1])*100).toString()+"% <br>"+"Depleting Consumables";
  
  this.chart = new Chart('requesttypehalfdonut', {
    
    type: 'doughnut',
    data: {
      labels:this.halfdonutrequesttypekey,
      
      datasets: [
        {
          data:this.halfdonutrequesttypevalue,
          backgroundColor: ["#eb0000","#d80000","#b10000","#890000","#620000","#3b0000","#140000","#3cba9f","#e8c3b9","#c45850","#ff6666","#3399FF","#FFFF66","#005ce6","#9999FF","#FF6666","#FFCCFF","#E0E0E0","#FFB266","#00FF80","#00FFFF","#0066CC","#9933FF","#FFFF00","#00CC66","#CC0066","#4286f4"],
          fill: false,
        //  borderColor: ["#00CC66","#003366"],
          borderWidth: [1, 1, 1, 1, 1]
        }
      ]
    },
    //options
     options : {
      responsive: true,
      title: {
          display: true,
          position: "bottom",
          text: "Request",
         
          fontColor: "#111"
      },
      cutoutPercentage: 70,
      maintainAspectRatio: false,
      rotation: 1 * Math.PI,
      circumference: 1 * Math.PI,
      
      legend: {
          display: true,
          position: "top",
          labels: {
              fontColor: "#333",
              fontSize: 10,
          }
      }
  }
  
      
    
      });
   },
    (err) => {
      this.error = err;
    }
  ); 
  }





gettotalappointmentsquare(){
  this._appointment.getAllAppointmentCountForBranch(this.branch,this.reportyear).subscribe(
    (res) => {

      this.totalappointmentsquare = res;
    
    });

}
  

gettotallookdescreqsquare(){
  this._appointment.getAllLookDescReqCountAllBranch(this.reportyear).subscribe(
    (res) => {
console.log(res);
      this.totallookingForsquare = res['lookingFor'];
      this.totaldescribesYousquare = res['describesYou'];
      this.totalrequestTypesquare = res['requestType'];
    
    });

}
  


gettotalsalesrepsquare(){
  this._appointment.getAllSalesRepCountForBranch(this.branch,this.reportyear).subscribe(
    (res) => {

      this.totalsalesrepsquare = res;
    
    });

}

getpopulardescribesYousquare(){
  this._appointment.getpopulardescribeYouForBranch(this.branch,this.reportyear).subscribe(
    (res) => {
console.log(res[0])
      this.populardescribesyousquarekey = res[0]['key'];
      this.populardescribesyousquarevalue = res[0]['value'];
    
    });
}

getpopularlookingForsquare(){
  this._appointment.getpopularlookingForForBranch(this.branch,this.reportyear).subscribe(
    (res) => {
console.log(res[0])
      this.popularlookingforsquarekey = res[0]['key'];
      this.popularlookingforsquarevalue = res[0]['value'];
    
    });
}


getallappointmentrequesttypeforbranchsquare(){
  this._appointment.getallappointmentrequesttypeforbranchsquare(this.branch,this.reportyear).subscribe(
    (res) => {
console.log(res[0])
      this.requesttypeforbranchsquare = res[0];
    
    
    });
}


  getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++ ) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;}



  isAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.Administrator;
  }
  
  isSystemAdmin() {
    return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
  }
  
  isReceptionist() {
    return this.currentUser && this.currentUser.role === UserRole.Receptionist;
  }
}
